import { boot } from 'quasar/wrappers'
import { install } from 'src/shared/components'
import 'src/shared/styles/index.sass'

export default boot(({ app }) => {
  install(app)
})
